import "./newsRoom.css";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import News from "./News";
import Footer from "../Footer";

import twitLogo from "../../assets/images/clay/x-clay.png";
import linkedinLogo from "../../assets/images/clay/linkedin-clay.png";
import yt_icon from '../../assets/images/clay/youtube-clay.png';

import featureBlog_1 from "../../assets/images/blog/test-blog.jpeg";
import featureBlog_2 from "../../assets/images/blog/blog-zapierSupport-asset.jpg";

import bump1_header from "../../assets/images/blog/blog-bump-1.jpg";

const NewsRoom = () => {
  // Helper function to generate URL-friendly slug
  const slugify = (text) =>
    text
      .toString()
      .toLowerCase()
      .replace(/\s+/g, "-") // Replace spaces with -
      .replace(/[^\w\-]+/g, "") // Remove non-word characters
      .replace(/\-\-+/g, "-") // Replace multiple - with a single -
      .replace(/^-+/, "") // Trim - from start
      .replace(/-+$/, ""); // Trim - from end

  const featured = [
    {
      img: featureBlog_1,
      category: "Featured",
      title: "API Documentation Now Live",
    },
    {
      img: featureBlog_2,
      category: "Featured",
      title: "Meet Bumpups on Zapier",
    },
  ];

  const socials = [
    {
      title: "Press inquiries",
      content: "press@bumpups.com",
    },
    {
      title: "Non-media inquiries",
      content: "contact@bumpups.com",
    },
    {
      title: "Follow Bumpups",
      // Updated order: LinkedIn now comes first, then X (Twitter)
      icons: [
        {
          name: "LinkedIn",
        },
        {
          name: "X",
        },
        {
          name: "YouTube",
        },
      ],
    },
  ];

  return (
    <div className="newsroom-main-container">
      <Helmet>
        <title>Bumpups | Newsroom</title>
        <meta
          name="description"
          content="Stay up-to-date with the latest from Bumpups. Our newsroom delivers cutting-edge product updates, exciting announcements, and industry insights on how our AI-driven video intelligence is transforming raw content into actionable data."
        />
      </Helmet>

      <div className="newsroom-title">Newsroom</div>

      <div className="newsroom-news-container">
        <div className="newsroom-header-box">
          {/* Announcements Section */}
          <Link
            to={`/news/${slugify("Introducing Bump-1.0 Model")}`}
            className="newsroom-announcements-box blog-no-underline"
          >
            <div className="newsroom-announcements-image-box">
              <img
                src={bump1_header}
                alt="example"
                className="newsroom-announcement-image"
              />
            </div>
            <div className="newsroom-announcement-text-container">
              <div className="newsroom-announcement-label">Announcements</div>
              <div className="newsroom-announcement-title">
              Introducing Bump-1.0 Model
              </div>
            </div>
          </Link>
          
          {/* Socials Section */}
          <div className="newsroom-socials-box">
            {socials.map((social, index) => (
              <div key={index} className="newsroom-social-item">
                <div className="newsroom-social-title">{social.title}</div>
                <div className="newsroom-social-content">
                  {social.content && social.content.includes("@") ? (
                    <a href={`mailto:${social.content}`}>{social.content}</a>
                  ) : (
                    social.content
                  )}
                </div>
                {social.icons && (
                  <div className="newsroom-social-icons">
                    {social.icons.map((icon, i) =>
                      icon.name === "X" ? (
                        <a
                          key={i}
                          href="https://x.com/bumpups"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="newsroom-social-icon twitter-icon"
                        >
                          <img src={twitLogo} alt="Twitter" />
                        </a>
                      ) : icon.name === "LinkedIn" ? (
                        <a
                          key={i}
                          href="https://www.linkedin.com/company/bumpups"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="newsroom-social-icon linkedin-icon"
                        >
                          <img src={linkedinLogo} alt="LinkedIn" />
                        </a>
                      ) : icon.name === "YouTube" ? (
                        <a
                          key={i}
                          href="https://www.youtube.com/@bumpupsapp"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="newsroom-social-icon youtube-icon"
                        >
                          <img src={yt_icon} alt="YouTube" />
                        </a>
                      ) : null
                    )}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
        {/* Featured Section */}
        <div className="newsroom-featured-boxes">
          {featured.map((feature, index) => (
            <Link
              key={index}
              to={`/news/${slugify(feature.title)}`}
              className={`newsroom-featured-box blog-no-underline ${
                index % 2 === 1 ? "featured-even" : "featured-odd"
              }`}
            >
              <div className="newsroom-featured-image-box">
                <img
                  src={feature.img}
                  className="newsroom-featured-image"
                  alt="example"
                />
              </div>
              <div className="newsroom-featured-text-container">
                <div className="newsroom-featured-category">
                  {feature.category}
                </div>
                <div className="newsroom-featured-title">{feature.title}</div>
              </div>
            </Link>
          ))}
        </div>
      </div>
      <News />
      <Footer />
    </div>
  );
};

export default NewsRoom;
